import { Card } from "@mui/material";

import useResponsive from "@/hooks/useResponsive";
import { useFeatureMedia } from "../utils/useFeatureMedia";

import CardImage from "./CardImage";
import Description from "./Description";
import Heading from "../Heading";
import { baseCardStyles, getFeatureCardStyles } from "./styles";

interface IProps {
  title: string;
  description: string;
  imageUrl: string;
  thumbnail: string;
}

const FeatureCard: React.FC<IProps> = ({
  title,
  description,
  imageUrl,
  thumbnail,
}) => {
  const isMobile = useResponsive("down", "md");
  const { isLargeScreen } = useFeatureMedia();

  return (
    <Card
      sx={{
        ...baseCardStyles,
        ...getFeatureCardStyles(isLargeScreen),
        display: isLargeScreen ? "flex" : "block",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <Heading title={title} isActive />

      {isMobile ? (
        <>
          <CardImage title={title} imageUrl={imageUrl} thumbnail={thumbnail} />
          <Description title={title} description={description} />
        </>
      ) : (
        <>
          <Description title={title} description={description} />
          <CardImage title={title} imageUrl={imageUrl} thumbnail={thumbnail} />
        </>
      )}
    </Card>
  );
};

export default FeatureCard;
